//
//
//
//
//
//

    export default {
        name: 'history',
        props: {
            history: Object
        },
        data() {
            return {
                userInfo: '',
                params: this.history,
                historyUrl: ''
            }
        },
        mounted() {
            const _this = this
            _this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            _this.init(_this.params)
        },
        watch: {
            params:{
                handler(newValue, oldValue) {
                    this.init(newValue)
                }
            }
        },
        methods: {
            init (info) {
                info.userId = this.userInfo.userid
                info.username = this.userInfo.username
                info.deptCode = this.DEPT_CODE.DEPTCODE

                if (this.historyUrl != info.url) {
                    this.$http.post('/api/wtcp-member/public/history?access_token=' + this.userInfo.access_token, info).then((response) => {
                        if (response.data.msg === 'success') {
                            this.historyUrl = info.url
                        }
                    })
                }
            }
        }
    }
